// extracted by mini-css-extract-plugin
module.exports = {"indentedNavItemLinkContainer":"style-module_indentedNavItemLinkContainer__Ejee3ngcQIXbsr0ZuJaH"};